import React from 'react';
import { ReactComponent as UtekollText } from '../resources/logos/textlogoUk.svg'
import UkLogo from '../resources/logos/logoUk256.png'

import '../styles/utekollLogo.scss'

export default function UtekollLogo() {
  return (
    <div className="utekoll-logo">
        <div className="uk-logo"><img alt="" src={UkLogo} style={{ width: 'inherit', height: 'inherit' }} /></div>
        <div className="uk-text"><UtekollText/></div>
    </div>
  );
}